import { DEFAULT_PAY_FREQUENCY, PAY_PERIODS_PER_MONTH } from "@torre/expenses";
import { getCurrentEnvironment } from "../../components/base/AppsSidebar/environmentVisibility.config";

// ---------------------------------------------------------------------------
// Sueldo registrado de cada colaborador (#1145)
// ---------------------------------------------------------------------------
// En el padrón `fixedSalary` es lo de UN periodo de pago; la empresa paga por
// quincena (`semimonthly`, el valor por omisión de `payFrequency`). El mensual
// sale de la MISMA regla que Gastos y la nómina pagada (`PAY_PERIODS_PER_MONTH`
// de @torre/expenses), para que las tres pantallas digan lo mismo.
//
// Un sueldo ausente, nulo, en cero o no numérico es «sin sueldo registrado»:
// «no sé» no es «cero».
// ---------------------------------------------------------------------------

export interface MemberSalary {
  /** Lo de un periodo (una quincena, por omisión). */
  amount: number;
  /** Código ISO de la ficha, o `null` si no lo declara (no se adivina). */
  currency: string | null;
  /** `semimonthly`, `weekly`, `biweekly` o `monthly`. */
  frequency: string;
  /** Equivalente mensual, en la misma moneda. */
  monthly: number;
}

/** Lee `fixedSalary`, `currency` y `payFrequency` de una ficha del padrón. */
export function memberSalary(member: Record<string, unknown>): MemberSalary | null {
  const amount = typeof member.fixedSalary === "number" ? member.fixedSalary : Number.NaN;
  if (!Number.isFinite(amount) || amount <= 0) return null;
  const raw = String(member.payFrequency || "").trim();
  const frequency = raw && PAY_PERIODS_PER_MONTH[raw] != null ? raw : DEFAULT_PAY_FREQUENCY;
  const code = String(member.currency ?? "").trim().toUpperCase();
  return {
    amount,
    currency: /^[A-Z]{3}$/.test(code) ? code : null,
    frequency,
    monthly: amount * PAY_PERIODS_PER_MONTH[frequency],
  };
}

/**
 * Los sueldos solo existen en PRODUCCIÓN: en desarrollo van nulos o de mentira
 * (el cargador del padrón se niega a escribir montos reales fuera de prod).
 * Mismo detector de ambiente que la visibilidad del menú de apps.
 */
export const salariesExistHere = (): boolean => getCurrentEnvironment() === "production";
